module.exports = __webpack_public_path__ + "static/media/personas.0f75c8df.csv";